// Generated by CoffeeScript 2.7.0
var LocationMixin;

export default LocationMixin = {
  data: function() {
    return {
      locating: false,
      locatingText: '定位中'
    };
  },
  methods: {
    getLocation: function(locateSuccessCallback = _.noop, enableChangeValue = true) {
      if (this.locating) {
        return;
      }
      this.locating = true;
      this.locatingText = '定位中';
      return Skylark.Libs.Geolocation.GetCurrentLocation((error, geoLocation) => {
        if (error) {
          this._alertError('获取定位失败');
          return this.locating = false;
        } else {
          this.locatingText = '解析中';
          return geoLocation.getRegeocode((_error, regeocode) => {
            this.locating = false;
            if (_error || _.isArray(regeocode.formattedAddress)) {
              // 不应该在这下面写 namespace specified 的代码
              return Skylark.Bridge.newAlertify({
                type: 'danger',
                content: '解析位置失败'
              });
            } else {
              this._current_location = regeocode.pois[0];
              if (enableChangeValue) {
                this.valueChange({
                  value: regeocode.formattedAddress,
                  latitude: geoLocation.position.latitude,
                  longitude: geoLocation.position.longitude,
                  accuracy: geoLocation.position.accuracy
                });
              }
              return locateSuccessCallback();
            }
          });
        }
      });
    },
    validateDistance: function() {
      var centerPoint, currentLocation;
      if (!(this.field.max_distance && this.field.remark)) {
        // 没有值，或没有制定点和指定距离，则认为合法
        return true;
      }
      if (!this.value) {
        return true;
      }
      currentLocation = new Skylark.Libs.Geolocation({
        position: this.value
      });
      centerPoint = new Skylark.Libs.Geolocation({
        position: {
          longitude: this.field.longitude,
          latitude: this.field.latitude
        }
      });
      if (!currentLocation.nearBy(centerPoint, this.field.max_distance)) {
        return this._addError("超出了限定范围");
      }
    },
    _validate: function() {
      this.validatePresence();
      return this.validateDistance();
    },
    _parseValueToEntries: function() {
      var _result, result;
      _result = [];
      if (this.entries.length) {
        result = _.clone(this.entries[0]);
        if (this.value) {
          _.extend(result, this.value);
          result._destroy = false;
        } else {
          if (result.id) {
            result._destroy = true;
          } else {
            result = null;
          }
        }
      } else {
        if (this.value) {
          result = _.extend({
            field_id: this.field.id
          }, this.value);
        }
      }
      if (result) {
        _result.push(result);
      }
      return _result;
    },
    _initDefaultEntries: function(entries) {
      return entries[0] || {};
    },
    _parseEntriesToValue: function(entry) {
      // as a position
      return this.value = entry.id ? _.pick(entry, 'value', 'latitude', 'longitude') : null;
    }
  }
};
